if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog2 {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner')?.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify?.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner')?.classList.add('hidden');

            const form = this.modalContent.querySelector('product-form');
            if (form) {
             
const buttoncart = this.modalContent.querySelector('.product-form__submit');
const baseText = buttoncart.getAttribute('data-text-btn') || buttoncart.textContent || '';

setupContenidoYPrecio(form, baseText);
              setupPackSelector(form);
            } else {
             
            }
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        productElement.querySelector('pickup-availability')?.remove();
        productElement.querySelector('product-modal')?.remove();
        productElement.querySelectorAll('modal-dialog').forEach(modal => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(sectionId, newId);
        Array.from(productElement.attributes).forEach((attr) => {
          if (attr.value.includes(sectionId)) {
            productElement.setAttribute(attr.name, attr.value.replace(sectionId, newId));
          }
        });
        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let sizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium')) sizes = sizes.replace('715px', '605px');
        if (product.classList.contains('product--small')) sizes = sizes.replace('715px', '495px');

        mediaImages.forEach((img) => img.setAttribute('sizes', sizes));
      }
    }
  );
}
function setupPackSelector(container) {
  console.log("⚙️ setupPackSelector ejecutado en:", container);

  let compraUnica = container.querySelector('.be-compra-unica input[type="checkbox"]');
  let ecoPack = container.querySelector('.be-compra-ahorro input[type="checkbox"]');
  const compraUnicaContainer = container.querySelector('#compra-unica');
  const ecoPackContainer = container.querySelector('#compra-ecopack');
  let quantityInput = container.querySelector('.be-quantity__input');
  const quantityContainer = container.querySelector('.be-quantity');

  if (!compraUnica || !ecoPack || !quantityInput || !quantityContainer || !compraUnicaContainer || !ecoPackContainer) {
    console.warn("❌ No se encontraron los elementos necesarios en:", container);
    return;
  }

  function updateSelection(selected, other, quantity) {
    if (selected.checked) {
      other.checked = false;
      setQuantity(quantity);
    } else {
      other.checked = true;
      setQuantity(other === compraUnica ? 1 : 3);
    }
  }

  function setQuantity(value) {
    quantityInput.value = value;
    quantityInput.setAttribute('value', value);
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    console.log("✅ Cantidad actualizada:", value);

    // ✅ Actualizar precio en el botón
    container._updateContenidoYPrecio?.();
  }

  quantityInput.addEventListener("input", () => {
    const qty = parseInt(quantityInput.value, 10) || 1;
    if (qty >= 3) {
      ecoPack.checked = true;
      compraUnica.checked = false;
    } else {
      compraUnica.checked = true;
      ecoPack.checked = false;
    }
    container._updateContenidoYPrecio?.();
  });

  quantityContainer.addEventListener("click", e => {
    if (e.target.closest('.quantity__button')) {
      setTimeout(() => {
        const qty = parseInt(quantityInput.value, 10) || 1;
        if (qty >= 3) {
          ecoPack.checked = true;
          compraUnica.checked = false;
        } else {
          compraUnica.checked = true;
          ecoPack.checked = false;
        }
        container._updateContenidoYPrecio?.();
      }, 50);
    }
  });

  compraUnica.addEventListener("change", () => {
    updateSelection(compraUnica, ecoPack, 1);
    container._updateContenidoYPrecio?.();
  });

  ecoPack.addEventListener("change", () => {
    updateSelection(ecoPack, compraUnica, 3);
    container._updateContenidoYPrecio?.();
  });

  compraUnicaContainer.addEventListener("click", () => {
    compraUnica.checked = true;
    ecoPack.checked = false;
    setQuantity(1);
  });

  ecoPackContainer.addEventListener("click", () => {
    ecoPack.checked = true;
    compraUnica.checked = false;
    setQuantity(3);
  });

  // Estado inicial
  if (!compraUnica.checked && !ecoPack.checked) {
    compraUnica.checked = true;
    setQuantity(1);
  }

  // 🎯 OBSERVER para detectar cambios en variantes dentro del container
  const observer = new MutationObserver(() => {
    quantityInput = container.querySelector('.be-quantity__input');
    compraUnica = container.querySelector('.be-compra-unica input[type="checkbox"]');
    ecoPack = container.querySelector('.be-compra-ahorro input[type="checkbox"]');

    const currentQty = parseInt(quantityInput?.value || 1, 10);

    if (ecoPack?.checked && currentQty !== 3) {
      console.log("🔁 Corrigiendo a 3 (EcoPack sigue activo)");
      setQuantity(3);
    } else if (compraUnica?.checked && currentQty !== 1) {
      console.log("🔁 Corrigiendo a 1 (Compra Única sigue activa)");
      setQuantity(1);
    }
  });

  observer.observe(container, {
    childList: true,
    subtree: true
  });
}

function formatPrice(amount) {
  const currencySymbols = {
    EUR: '€',
    USD: '$',
    GBP: '£',
    MXN: '$',
  };
  const currencyCode = Shopify.currency?.active || Shopify.shop_currency || ShopifyAnalytics?.meta?.currency || 'EUR';
  const symbol = currencySymbols[currencyCode] || currencyCode;
  const userLocale = navigator.language || 'es-CO';

  const priceNumber = amount / 100;
  const formattedNumber = new Intl.NumberFormat(userLocale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(priceNumber);

  return formattedNumber;
}

function setupContenidoYPrecio(container, baseText) {
  console.log("⚙️ setupContenidoYPrecio ejecutado en:", container);

  const rawJSON = container.getAttribute('data-variant');
  const variantInput = container.querySelector('.product-variant-id');
  if (!rawJSON || !variantInput) {
    console.warn("❌ Faltan datos en el contenedor:", container);
    return;
  }

  let variantMap = {};
  try {
    variantMap = JSON.parse(rawJSON);
  } catch (error) {
    console.error("❌ JSON inválido en data-variant:", error, rawJSON);
    return;
  }

  const buttoncart = container.querySelector('.product-form__buttons .product-form__submit');
  const spanContenido = container.querySelector('.variant-contenido');
  const priceElement = container.querySelector('.be-compra-unica .compra-price');
  const ecoPackPriceElement = container.querySelector('.be-compra-ahorro .compra-price');
  const originalPriceElement = container.querySelector('.be-compra-ahorro small');
  const ecoPack = container.querySelector('.be-compra-ahorro input[type="checkbox"]');
  const quantityInput = container.querySelector('.be-quantity__input');

  function updateUI() {
    const variantId = variantInput.value;
    const variantData = variantMap[variantId];
    if (!variantData) return;

    const precioUnitario = variantData.price;
    const precioEcoPack = Math.round(precioUnitario * 0.95);

    const precioUnitarioFormatted = formatPrice(precioUnitario);
    const precioEcoPackFormatted = formatPrice(precioEcoPack);

    const cantidad = parseInt(quantityInput?.value || 1, 10);
    const ecoActivo = ecoPack?.checked || cantidad >= 3;

    if (buttoncart) {
      buttoncart.innerHTML = `${baseText} - ${ecoActivo ? precioEcoPackFormatted : precioUnitarioFormatted}`;
    
    }

    if (spanContenido) spanContenido.textContent = variantData.contenido || '';
    if (priceElement) priceElement.textContent = precioUnitarioFormatted;
    if (ecoPackPriceElement) ecoPackPriceElement.innerHTML = `${precioEcoPackFormatted} <br>`;

    if (originalPriceElement) {
      originalPriceElement.textContent = precioUnitarioFormatted;
      originalPriceElement.style.display = precioUnitarioFormatted !== formatPrice(0) ? "inline" : "none";
    }
  }

  // 👉 Exponemos la función para que pueda llamarla setupPackSelector
  container._updateContenidoYPrecio = updateUI;

  updateUI();
  variantInput.addEventListener('change', updateUI);
}



